import { render, staticRenderFns } from "./rCuenta.vue?vue&type=template&id=5f875c9c"
import script from "./rCuenta.vue?vue&type=script&lang=js"
export * from "./rCuenta.vue?vue&type=script&lang=js"
import style0 from "./rCuenta.vue?vue&type=style&index=0&id=5f875c9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports